import styled from "styled-components";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Close from "../assets/img/Cancel.svg";

const StyledModalBackground = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.5;
  z-index: 5;
`;

const StyledBottomSheet = styled.div`
  z-index: 6;
  position: fixed;
  width: 100%;
  height: 100vh;
  &::-webkit-scrollbar {
    display: none;
  }
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #000;
  text-align: center;
  & > .close {
    position: relative;
    top: 1rem;
    & > img {
      position: absolute;
      right: 1rem;
      z-index: 20;
    }
  }
`;

const StyledBottomSheetContent = styled.div`
  height: 90%;
  width: 100%;
  position: relative;
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-sizing: content-box;
  overflow: hidden;

  & > div {
    font-weight: 500;
    font-size: 14px;
    line-height: 1.7rem;
    width: 100%;
    position: absolute;
    box-sizing: border-box;
    overflow: hidden;
    height: 100%;
    color: rgba(0, 200, 140, 1);
    text-align: center;
  }
`;

function ImgModal({ closeModal, children, navi }) {
  const navigate = useNavigate();
  /**모바일 기종 분기처리 (ios, 안드로이드, 그 외) */
  const [phoneType, setPhoneType] = useState();
  var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
  // function checkMobile() {

  //   if (varUA.indexOf("android") > -1) {
  //     //안드로이드
  //     setPhoneType("android");
  //     return "android";
  //   } else if (
  //     varUA.indexOf("iphone") > -1 ||
  //     varUA.indexOf("ipad") > -1 ||
  //     varUA.indexOf("ipod") > -1
  //   ) {
  //     //IOS
  //     setPhoneType("ios");
  //     return "ios";
  //   } else {
  //     //아이폰, 안드로이드 외
  //     setPhoneType("other");
  //     return "other";
  //   }
  // }
  // useEffect(() => {
  //   checkMobile();
  // }, []);


  const clickOk = () => {
    closeModal();
    if (navi === true) {
      // navigate(navi)
      // if (phoneType === "ios") {
      //   window.webkit.messageHandlers.movusCallBack.postMessage({
      //     command: "back",
      //   });
      // } else {
      //   // window.androidWebViewApi.movusCallBack({ command: "back" });
      //   window.postMessageToAndroid.movusCallBack({ command: "back" });
      // }
      if (varUA.indexOf("android") > -1) {
        //안드로이드
        window.postMessageToAndroid.movusCallBack("back");
        // setPhoneType("android");
        return "android";
      } else if (
        varUA.indexOf("iphone") > -1 ||
        varUA.indexOf("ipad") > -1 ||
        varUA.indexOf("ipod") > -1
      ) {
        //IOS
        window.webkit.messageHandlers.movusCallBack.postMessage({
          command: "back",
        });
        // setPhoneType("ios");
        return "ios";
      } else {
        window.postMessageToAndroid.movusCallBack("back");
        //아이폰, 안드로이드 외
        // setPhoneType("other");
        return "other";
      }
    }
  };
  return (
    <>
      <StyledModalBackground />
      <StyledBottomSheet>
        <div className="close">
          <img src={Close} alt="" onClick={clickOk} />
        </div>
        <StyledBottomSheetContent>
          <div>{children}</div>
        </StyledBottomSheetContent>
      </StyledBottomSheet>
    </>
  );
}

export default ImgModal;
